import * as _ from "lodash";

// A product can be listed in more than one category: a promo category such as
// «Δημοφιλή» holds copies of products that belong to other categories. Show the
// product's own category when it is active, else the one the search matched.
export function getSearchResultCategoryName(
  product: any,
  matchedCategory: any,
  allCategories: any
) {
  const ownCategory: any =
    product && product.category_id
      ? _.find(allCategories, { category_id: product.category_id })
      : null;

  if (ownCategory && ownCategory.activeTotal && ownCategory.name) {
    return ownCategory.name;
  }

  return matchedCategory && matchedCategory.name ? matchedCategory.name : null;
}
